<template>
  <m-card206 class="content-card-206" :image="content.thumbnail" :alt="content.title">
    <template #p-1>
      <p class="content-card-206-title">
        {{ content.title }}
      </p>
    </template>
    <template #p-2>
      <div class="content-card-206-description" v-html="content.description"></div>
    </template>
  </m-card206>
</template>

<script>
import mCard206 from "../../Cards/Card206";
import mImg from '../../Tags/Img'

export default {
  name: "ContentCard206",
  components: {mCard206, mImg},
  props: {
    content: {}
  },
}
</script>

<style scoped>
.content-card-206-title {
  font-size: 14px;
}
</style>